import React from 'react';

const Room = (props) => (
  <svg viewBox="0 0 14.497 16.58" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <style>{`.roomIconClass{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:0.5px;}`}</style>
    </defs>
    <g transform="translate(0.372 0.354)">
      <path
        className="roomIconClass"
        transform="translate(-74.287 -257.205)"
        d="M81.25,273.028l6.7-3.868a.173.173,0,0,0,.087-.15v-7.736a.174.174,0,0,0-.087-.151l-6.7-3.868a.174.174,0,0,0-.174,0l-6.7,3.868a.174.174,0,0,0-.087.151v7.736a.173.173,0,0,0,.087.15l6.7,3.868A.175.175,0,0,0,81.25,273.028Z"
      />
      <path
        className="roomIconClass"
        transform="translate(-74.287 -257.205)"
        d="M88.037,269.11l-6.787-3.918a.175.175,0,0,0-.174,0L74.29,269.11"
      />
      <line className="roomIconClass" y1="7.937" transform="translate(6.877)" />
      <path
        className="roomIconClass"
        transform="translate(-74.287 -257.205)"
        d="M85.6,262.483l-1.9-1.1a.174.174,0,0,0-.261.15v4.919l2.253,1.3v-5.12A.175.175,0,0,0,85.6,262.483Z"
      />
      <line
        x1="6.88"
        y2="3.97"
        className="roomIconClass"
        transform="translate(0 7.937)"
      />
      <path
        className="roomIconClass"
        transform="translate(-74.287 -257.205)"
        d="M76.374,262.277l2.532-1.461a.174.174,0,0,1,.261.151v2.92a.175.175,0,0,1-.087.15L76.548,265.5a.174.174,0,0,1-.261-.151v-2.92A.174.174,0,0,1,76.374,262.277Z"
      />
    </g>
  </svg>
);

export default Room;
